import { render, staticRenderFns } from "./AppendSearchableAttribute.vue?vue&type=template&id=1ef1926a&"
import script from "./AppendSearchableAttribute.vue?vue&type=script&lang=js&"
export * from "./AppendSearchableAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports